module.exports = __webpack_public_path__ + "img/31_18.2af0a50d.png";